import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <h1>This is my website.</h1>
    </div>
  );
}

export default App;
